import { render, staticRenderFns } from "./WidgetCenter.vue?vue&type=template&id=f529b3a4&scoped=true"
import script from "./WidgetCenter.vue?vue&type=script&lang=js"
export * from "./WidgetCenter.vue?vue&type=script&lang=js"
import style0 from "./WidgetCenter.vue?vue&type=style&index=0&id=f529b3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f529b3a4",
  null
  
)

export default component.exports